import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 're2006',
    ecrans: ['00-2'],
    params: [
        'rslcleint'
    ]
});
